<template>
  <div class="login-footer">
    <p>
      <svg-icon icon-class="contact" />
      {{customerService.tel}} {{customerService.time}}
      <divider type="vertical" />
      <a href="#">购物帮助</a>
      <divider type="vertical" />
      <a href="#">配送</a>
      <divider type="vertical" />
      <a href="#">企业合作</a>
    </p>
    <p style="font-size: 12px;">
      {{copyright}} {{icp}}
    </p>
  </div>
</template>

<script>
import config from '@/config'
export default {
  data() {
    return {
      copyright: config.copyright,
      icp: config.icp,
      customerService: config.customerService,
    }
  }
}
</script>

<style scoped lang="less">
  .login-footer {
    a {
      color: #595757;
    }
    margin-top: 45px;
    text-align: center;
    color: #595757;
    font-weight: 600;
    .divider {
      background: #595757;
    }
    p {
      padding: 2px 0;
    }
  }
</style>
